import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BarChart3 } from 'lucide-react';

function driStatusBand(score) {
  if (score >= 80) {
    return {
      label: 'Compliance Verified',
      pillBg: 'rgba(63, 185, 80, 0.2)',
      pillColor: '#3fb950',
    };
  }
  if (score >= 60) {
    return {
      label: 'Needs Attention',
      pillBg: 'rgba(224, 155, 26, 0.2)',
      pillColor: '#E09B1A',
    };
  }
  return {
    label: 'Needs Setup',
    pillBg: 'rgba(248, 81, 73, 0.2)',
    pillColor: '#f85149',
  };
}

function formatFleetSubscore(v) {
  if (v == null || Number.isNaN(Number(v))) return '—';
  return String(Math.round(Number(v)));
}

export default function DriScoreHero({ score, loading, attentionCount, variant = 'personal', fleetMetrics }) {
  const navigate = useNavigate();
  const isFleet = variant === 'fleet';
  const safeScore = typeof score === 'number' && !Number.isNaN(score) ? Math.min(100, Math.max(0, score)) : 0;
  const band = driStatusBand(safeScore);
  const count = typeof attentionCount === 'number' ? attentionCount : 0;
  const countPhrase =
    count === 0 ? 'Nothing needs your attention right now.' : `${count} item${count !== 1 ? 's' : ''} need your attention.`;

  return (
    <section
      className="dashboard-dri-hero"
      aria-label={isFleet ? 'Fleet DRI Score' : 'DRI Score'}
      data-tour="dashboard-dri-hero"
    >
      <div className="dashboard-dri-hero__inner">
        <div className="dashboard-dri-hero__label-row">
          <BarChart3 size={28} className="dashboard-dri-hero__icon" aria-hidden />
          <span className="dashboard-dri-hero__brand">{isFleet ? 'Fleet DRI Score™' : 'DRI Score™'}</span>
        </div>
        {loading ? (
          <p className="dashboard-dri-hero__loading">{isFleet ? 'Loading fleet score…' : 'Loading your score…'}</p>
        ) : (
          <>
            <div className="dashboard-dri-hero__score-row">
              <span className="dashboard-dri-hero__score">{safeScore}</span>
              <span className="dashboard-dri-hero__max">/ 100</span>
            </div>
            <span
              className="dashboard-dri-hero__badge"
              style={{ backgroundColor: band.pillBg, color: band.pillColor }}
            >
              {band.label}
            </span>
            {isFleet && fleetMetrics ? (
              <p className="dashboard-dri-hero__fleet-components">
                Owner: {formatFleetSubscore(fleetMetrics.ownerScore)} | Vehicles:{' '}
                {formatFleetSubscore(fleetMetrics.vehicleScore)} | Drivers: {formatFleetSubscore(fleetMetrics.driverScore)}
              </p>
            ) : null}
            <p className="dashboard-dri-hero__copy">
              {isFleet ?
                'Your fleet score blends your authority and documentation standing with vehicle readiness and driver compliance.'
              : 'Your score is based on document completeness, vehicle readiness, and authority standing.'}
            </p>
            <p className="dashboard-dri-hero__count">{countPhrase}</p>
            <button type="button" className="dashboard-dri-hero__cta" onClick={() => navigate('/analytics')}>
              View Full Breakdown
            </button>
          </>
        )}
      </div>
    </section>
  );
}
